/* eslint-disable */
function GetQueryString(name){
	var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if(r!=null)return  unescape(r[2]); return null;
}

function ValRound(val, round=0) {
	val = Math.round(val * 10**round) / (10**round)
  if (isNaN(val) || val == 0) {
		return '--'
	}else{
		if (val == -1){
			return '--'
		}
		return val
	}
}



// 判断是否是数字
function isNumber(v) {
	// Math.round 会把空值和null转为0
	if(v === "" || v == null){
			return false;
　　}

	if (isNaN(Math.round(v))) {
			return false;
	}else {
			return true;
	}
}


function sortArray({array, key, order}) {
	var data_valid = []
	var data_invalid = []
	array.forEach(element => {
			var v = element[key]
			if (isNumber(v)) {
					data_valid.push(element)
			}else{
					data_invalid.push(element)
			}
	});
	data_valid.sort(function(x, y) {
			return x[key] - y[key]
	})
	if (order === 'desc') {
			data_valid.reverse()
	}
	return [...data_valid, ...data_invalid]
}


export {
	GetQueryString,
	ValRound,
	sortArray
}